import { useEffect } from 'react';
import { useToast } from '../hooks/use-toast';

/**
 * SessionTimeoutHandler - Listens for session timeout events and displays a toast notification
 * This component should be placed inside the app after the Toaster component
 */
const SessionTimeoutHandler = () => {
  const { toast } = useToast();

  useEffect(() => {
    const handleSessionTimeout = (event) => {
      const { userType, message } = event.detail || {};
      
      toast({
        title: '⏱️ Session Timed Out',
        description: message || 'Your session has expired. Please log in again.',
        variant: 'destructive',
        duration: 6000, // Show for 6 seconds
      });
      
    };

    // Listen for session timeout events from AuthContext
    window.addEventListener('session-timeout', handleSessionTimeout);

    return () => {
      window.removeEventListener('session-timeout', handleSessionTimeout);
    };
  }, [toast]);

  // This component doesn't render anything
  return null;
};

export default SessionTimeoutHandler;
